module.exports = __webpack_public_path__ + "img/logo.665563f7.png";